module.exports = __webpack_public_path__ + "static/media/add_language.e7b3754b.png";